import { Authorization, getLookupAsync } from "@serenity-is/corelib";

export interface GardenSelectionOptions {
    menu: HTMLElement;
}

interface GardenLookupRow {
    Id?: number;
    Name?: string;
}

// Populates the #s-garden-selection-menu dropdown (rendered by Views/Shared/_Sidebar.cshtml) from
// the AppAdministration.Gardens lookup, marks the user's current garden active, and reloads the
// page with a CurrentGarden cookie set on click. Server side, UserRetrieveService reads this same
// cookie to resolve UserDefinition.GardenId per-request (see its ApplyCurrentGarden). Ported from
// the old app's HappyVegi.Common.GardenSelection widget (a <select> populated the same way); the
// new sidebar markup uses a Bootstrap dropdown <ul> instead, so this is a plain init function
// around that shape, same approach as LanguageSelection.ts.
export async function initGardenSelection(options: GardenSelectionOptions) {
    var lookup = await getLookupAsync<GardenLookupRow>("AppAdministration.Gardens");
    if (!lookup.items.length)
        return;

    var currentGardenId = (Authorization.userDefinition as { GardenId?: number })?.GardenId;

    options.menu.innerHTML = "";

    for (const item of lookup.items) {
        var a = document.createElement("a");
        a.className = "dropdown-item" + (item.Id === currentGardenId ? " active" : "");
        a.href = "#";
        a.textContent = item.Name;
        a.addEventListener("click", e => {
            e.preventDefault();
            document.cookie = `CurrentGarden=${item.Id}; path=/; max-age=${365 * 24 * 60 * 60}`;
            window.location.reload();
        });

        var li = document.createElement("li");
        li.appendChild(a);
        options.menu.appendChild(li);
    }
}
